import { render, staticRenderFns } from "./deletedClients.vue?vue&type=template&id=1a9b9f34&scoped=true&"
import script from "./deletedClients.vue?vue&type=script&lang=js&"
export * from "./deletedClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b9f34",
  null
  
)

export default component.exports